import { lockedLineItemsActions } from 'store/slices/lockedLineItemsSlice';

export const handleLineItemsLocked = (payload) => (dispatch) => {
  const { data } = payload;
  const items = Array.isArray(data) ? data : [data];

  items.forEach((item) => {
    const { lineItemIds, user, enhancedLockDetails } = item;

    if (lineItemIds && user && user.userId) {
      dispatch(
        lockedLineItemsActions.addLockedLineItems({
          lineItemIds,
          user,
          enhancedLockDetails,
        })
      );
    }
  });
};

export const handleLineItemsUnlocked = (payload) => (dispatch) => {
  const { data } = payload;
  const items = Array.isArray(data) ? data : [data];

  items.forEach((item) => {
    const { lineItemIds, user, enhancedLockDetails } = item;

    if (lineItemIds && user && user.userId) {
      dispatch(
        lockedLineItemsActions.removeLockedLineItems({
          lineItemIds,
          user,
          enhancedLockDetails,
        })
      );
    }
  });
};

export const clearAllLockedItems = () => (dispatch) => {
  dispatch(lockedLineItemsActions.clearAllLockedItems());
};

export const clearUserLockedItems = (userId) => (dispatch) => {
  dispatch(lockedLineItemsActions.clearUserLockedItems({ userId }));
};

export const handleAppLockedLineItems = (payload) => (dispatch) => {
  const { data } = payload;

  if (data) {
    const dataArray = Array.isArray(data) ? data : [data];
    dispatch(lockedLineItemsActions.loadAppLockedLineItems({ data: dataArray }));
  }
};

export const handleLineItemsExpired = (payload) => (dispatch) => {
  const { data } = payload;

  if (data && Array.isArray(data)) {
    let lineItemIds = [];
    let enhancedLockDetails = null;

    if (data.length > 0 && typeof data[0] === 'object' && data[0].enhancedLockDetails) {
      enhancedLockDetails = data[0].enhancedLockDetails;
      lineItemIds = data[0].lineItemIds || [];
    } else {
      lineItemIds = data.flat();
    }

    dispatch(
      lockedLineItemsActions.removeExpiredLineItems({
        lineItemIds,
        enhancedLockDetails,
      })
    );
  }
};
